<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">   

        <!-- //TITLE MOBILE -->
          <div class="mobile"  :class="{isMobile:isMobile}">
            <div class="link">
              <button class="bt btn-back" @click="goBack()">
                <font-awesome-icon :icon="['far', 'angle-left']"/>
              </button>
              <h2>Jeu concours</h2>
            </div>
            <div class="sep"></div>
          </div>
        <!-- //TITLE MOBILE -->

    <div  class="block__challengesAccueil  content__challengesAccueil"> 

      <ion-item class="refresh mobile">
        <span class="badge">
          <font-awesome-icon :icon="['far', 'sync']" />
        </span>
        <PuSkeleton :loading="isLoading" :count="1" width="180px">  
          Mise à jours le lundi 30 mars 2020
        </PuSkeleton>
      </ion-item>

      <!-- //TITLE DESKTOP -->
      <div class="desktop">
        <div class="header-sub">
            <div class="entete">
              <p>Jeu concours</p>
            </div>        
            
            <ion-item class="refresh">
              <span class="badge">
                <font-awesome-icon :icon="['far', 'sync']" />
              </span>
              <PuSkeleton :loading="isLoading" :count="1" width="180px">  
                Mise à jours le lundi 30 mars 2020
              </PuSkeleton>
          </ion-item>
        </div>
      </div>
      <!-- //TITLE DESKTOP -->

      <!-- //CARD ENTETE -->
      <cardChallengesHeader
      subtitle = 'Jeu concours'
      title = 'Pura Vida'
      targetTitle = 'En cours'
      ranking = "Classement"
      rankingNumber = "82"
      rankingResult = "15"
      score = "score"
      scoreNumber = "250 000"
      target = "+1"
      />
      <!-- //CARD ENTETE -->



      <!-- SLIDER MOBILE -->
      <div class="block__slider mobile">
        <VueSlickCarousel v-bind="settings">
          <div  class="wrapper">
            <cardChallengesRanking
            title = 'Top semaine'
            />
          </div>

          <div  class="wrapper">
            <cardChallengesRanking
            title = 'Top semaine'
            color = 'green'
            />         
          </div>

          <div  class="wrapper">
            <cardChallengesRanking
            title = 'Top semaine'
            color = 'red'
            />
          </div>
        </VueSlickCarousel>
      </div>
      <!-- SLIDER MOBILE -->


      <!-- SLIDER DESKTOP -->
      <b-row class="block__ranking" v-if="!isMobile">
        <b-col sm="12" lg="4">
          <cardChallengesRanking
          title = 'Top semaine'
          />
        </b-col>
        <b-col sm="12" lg="4">
          <cardChallengesRanking
          title = 'Top semaine'
          color = 'green'
          />
        </b-col>
        <b-col sm="12" lg="4">
          <cardChallengesRanking
          title = 'Top semaine'
          color = 'red'
          />
        </b-col>
      </b-row>
      <!-- SLIDER DESKTOP -->


      <!-- BLOCK CARD DESTINATION -->
      <b-row class="block__cardDestination">
        <b-col sm="12">
          <cardChallengesPostCard />
        </b-col>
      </b-row>
      <!-- BLOCK CARD DESTINATION -->


      <!-- //TITLE -->
      <div class="entete title">
        <p>Actualités concours</p>
      </div>
      <!-- //TITLE -->



      <!-- SLIDER MOBILE -->
      <div class="block__slider  blog mobile">
        <VueSlickCarousel v-bind="settings">
          <div  class="wrapper">
            <cardPost />
          </div>
          <div  class="wrapper">
            <cardPost />
          </div>
          <div  class="wrapper">
           <cardPost />
          </div>
        </VueSlickCarousel>
      </div>
      <!-- SLIDER MOBILE -->


      <!-- BLOCK CARD BLOG -->
      <b-row class="block__cardBlog">
        <b-col sm="12" lg="4">
          <cardPost />
        </b-col>
        <b-col sm="12" lg="4">
          <cardPost />
        </b-col>
        <b-col sm="12" lg="4">
          <cardPost />
        </b-col>
      </b-row>
      <!-- BLOCK CARD BLOG -->

    </div>

  </section>
</template>


<script>
import ParentMixin from '../../ParentMixin'
import { mapGetters } from 'vuex'
import cardChallengesHeader from '../../../module/card/CardChallengesHeader'
import cardChallengesRanking from '../../../module/card/CardChallengesRanking'
import cardChallengesPostCard from '../../../module/card/CardChallengesPostCard'
import cardPost from '../../../module/card/CardPost'


export default {
  name:"challengesAccueil",
    components:{
      cardChallengesHeader,
      cardChallengesRanking,
      cardChallengesPostCard,
      cardPost,
    }, 
    mixins: [
      ParentMixin
    ],
    computed: {
      ...mapGetters([
        'getBrowse',
      ])
    },
    data () {
      return {
        content:"",
        isLoading:true,
      }
    },
    created (){
      this.content = this.getBrowse;
      setTimeout(() => {
        this.isLoading = false;
        // this.majData();
      },2000)         
    },
    methods : {   
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },   
      swipeRightHandler () {
          this.goBack();
      },                    
    }    
  };
</script>
